import React from 'react';

interface RadioOption {
  id: string | number;
  value: string;
  content?: React.ReactNode;
  labelClass?: string;
}

interface ValidationResult {
  success: boolean;
  message?: string;
}

interface RadioInputsProps {
  id?: string;
  options?: RadioOption[];
  smBlockClass?: string;
  value?: string | number;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  validationResult?: ValidationResult;
  invalidLabel?: boolean;
  showInvalidLabel?: boolean;
  name?: string;
  className?: string;
  placeholder?: string;
  updateHandler?: (value: string, stateType?: string) => void;
  stateType?: string;
}

const RadioInputs = (props: RadioInputsProps) => {
  const { stateType, updateHandler, name, value, options } = props;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (stateType) {
      updateHandler?.(e.target.value, stateType);
    } else {
      updateHandler?.(e.target.value);
    }
  };

  const optionsPart = options?.map((opt) => {
    const checked = opt.value === value;
    const content = opt.content ? opt.content : opt.value;
    const labelClass = opt.labelClass;
    return (
      <label key={`${name}-${opt.id}`} className={labelClass}>
        <input
          key={`${name}-${opt.id}`}
          type="radio"
          name={name}
          value={opt.value}
          checked={checked}
          onChange={handleChange}
        />
        {content}
      </label>
    );
  });
  const wrapperClass = '';
  return <div className={wrapperClass}>{optionsPart}</div>;
};

export default RadioInputs;
